import React from 'react';
import { useBreakpoint } from '@moda/om';
import { LazyLoad, EnableLazyLoad } from '../LazyLoad';
import { PlaceholderCell } from './GridCell';
import { Grid, GridProps } from './Grid';

type LazyGridProps = GridProps & {
  children: React.ReactElement[];
  onLazyCellsLoad?: () => void;
};

const INITIAL_MOBILE_CELL_COUNT = 4;
const INITIAL_DESKTOP_CELL_COUNT = 10;

export const LazyGrid: React.FC<LazyGridProps> = ({ onLazyCellsLoad, children, ...rest }) => {
  const { matches: isMobile } = useBreakpoint({ lt: 'xs' });
  const initialCellsCount = isMobile ? INITIAL_MOBILE_CELL_COUNT : INITIAL_DESKTOP_CELL_COUNT;

  const initialCells = React.Children.toArray(children).slice(0, initialCellsCount);
  const lazyCells = React.Children.toArray(children).slice(initialCellsCount);

  return (
    <Grid {...rest}>
      {initialCells}
      <EnableLazyLoad>
        {lazyCells.map((cell, index) => (
          <LazyLoad
            key={(cell as React.ReactElement).key}
            fallback={<PlaceholderCell />}
            onLoad={index === 0 ? onLazyCellsLoad : undefined}
          >
            {cell}
          </LazyLoad>
        ))}
      </EnableLazyLoad>
    </Grid>
  );
};
